import ReactGA from 'react-ga';
import ym from 'react-yandex-metrika';

export const sendEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
  console.log(`${category}-${action}-${label}`)
  ym('reachGoal', `${category}-${action}-${label}`)
}

export const pageView = (page) => {
  ReactGA.ga('send', 'pageview', page);
  ym('hit', page);
}


// WEBPACK FOOTER //
// ./src/helpers/analytics.js